<div class="p-4 flex flex-col gap-4">
  <!-- Process Flow -->
  <div class="hh-menu-card" (click)="goToProcessFlow()">
    <div class="flex items-center gap-3">
      <i class="pi pi-box hh-menu-icon"></i>
      <div>
        <div class="text-lg font-semibold">Process Flow</div>
        <div class="text-sm opacity-70">Scan bins &amp; items into stations</div>
      </div>
    </div>
    <i class="pi pi-chevron-right opacity-50"></i>
  </div>

  <!-- Reserved #1 -->
  <div class="hh-menu-card hh-menu-disabled">
    <div class="flex items-center gap-3">
      <i class="pi pi-lock hh-menu-icon"></i>
      <div>
        <div class="text-lg font-semibold">Reserved #1</div>
        <div class="text-sm opacity-50">Coming soon</div>
      </div>
    </div>
  </div>

  <!-- Reserved #2 -->
  <div class="hh-menu-card hh-menu-disabled">
    <div class="flex items-center gap-3">
      <i class="pi pi-lock hh-menu-icon"></i>
      <div>
        <div class="text-lg font-semibold">Reserved #2</div>
        <div class="text-sm opacity-50">Coming soon</div>
      </div>
    </div>
  </div>
</div>
